import "bootstrap/dist/css/bootstrap.min.css";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./App.css";
import "./Assets/css/responsive.css";
import "./Assets/css/style.css";
import AuthLayout from "./layout/Auth/authLayout";
import MainLayout from "./layout/MainLayout/MainLayout";
import { privateRoutes, publicRoutes, routes } from "./pages/index";

function App() {
	const isAuthenticated = useSelector((s) => s.login.token);
	return (
		<Routes>
			{isAuthenticated ? (
				<Route element={<MainLayout />}>
					<Route path="*" element={<Navigate replace to="/dashboard" />} />
					{privateRoutes.map((data, index) => (
						<Route
							onUpdate={() => window.scrollTo(0, 0)}
							exact={true}
							path={data.path}
							element={data.component}
							key={index}
						/>
					))}
				</Route>
			) : (
				<Route element={<AuthLayout />}>
					<Route path="*" element={<Navigate replace to="/login" />} />
					{routes.map((data, index) => (
						<Route
							onUpdate={() => window.scrollTo(0, 0)}
							exact={true}
							path={data.path}
							element={data.component}
							key={index}
						/>
					))}
				</Route>
			)}
			{/* Route for delvit public link html.  */}
			{publicRoutes.map((data, index) => (
				<Route
					onUpdate={() => window.scrollTo(0, 0)}
					exact={true}
					path={data.path}
					element={data.component}
					key={index}
				/>
			))}
		</Routes>
	);
}

export default App;
